"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Extender = void 0;
/**
 * Extender
 * Stateful wrapper around StormUI's Extender component.
 */
var react_1 = __importStar(require("react"));
var storm_ui_1 = require("@amzn/storm-ui");
var Extender = function (_a) {
    var expandLabel = _a.expandLabel, collapseLabel = _a.collapseLabel, _b = _a.isOpen, isOpen = _b === void 0 ? false : _b, children = _a.children;
    var _c = (0, react_1.useState)(isOpen), isExpanded = _c[0], setIsExpanded = _c[1];
    var handleClick = function () {
        setIsExpanded(function (prev) { return !prev; });
    };
    return (react_1.default.createElement(storm_ui_1.Extender, { label: isExpanded ? collapseLabel : expandLabel, handleClick: handleClick, isOpen: isExpanded }, children));
};
exports.Extender = Extender;
